import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = [
    'associationInput',
    'singleStateMessage',
    'stateInput',
  ]

  connect() {
    this.handleAssociationChange()
  }

  handleAssociationChange() {
    if (this.associationInputTarget.value === 'naa') {
      enter(this.stateInputTarget)
      leave(this.singleStateMessageTarget)
    } else {
      leave(this.stateInputTarget)
      enter(this.singleStateMessageTarget)
    }
  }
}
